<template>
  <ValidationObserver v-slot="{ valid }">
    <unicom-filtro-v2
      titulo="Filtrar PTU"
      :value="mostrar"
      @limpar-filtro="limpar"
      @fechar="fecharFiltro"
      @filtrar="filtrar"
      :bloquearBotaoFiltro="!valid"
    >
      <div slot="corpo-subtitulo">
        Selecione os dados desejados,<br />
        depois clique em FILTRAR.
      </div>
      <div slot="corpo-filtro" style="margin: 0 32px">
        <unicom-linha espacamento class="fonte-secundaria espacamento-filtro">
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-autocomplete
              mostrarIconeExcluir
              colorPlaceholder="#9E9E9E"
              placeholder="Selecione um tipo"
              titulo="Tipo"
              v-model="objetoFiltro.tipo.descricao"
              @index="index => selecionarChave(index, 'tipo', listaTipos)"
              :items="listaTipos.map(e => e.descricao)"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-autocomplete
              mostrarIconeExcluir
              colorPlaceholder="#9E9E9E"
              placeholder="Todas as Unimeds"
              titulo="Unimed Origem"
              v-model="objetoFiltro.unimedOrigem.descricao"
              @index="selecionarUnimed"
              :items="listaUnimedOrigem.map(e => e.textoExibicao)"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-autocomplete
              mostrarIconeExcluir
              colorPlaceholder="#9E9E9E"
              placeholder="Selecione uma rede"
              titulo="Rede"
              v-model="objetoFiltro.rede.descricao"
              @index="index => selecionarChave(index, 'rede', listaRedes)"
              :items="listaRedes.map(e => e.descricao)"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-campo-texto
              maxCaracteres="60"
              :icone="objetoFiltro.documento ? 'x' : ''"
              ladoIcone="direito"
              clickIcone
              @click-icone="objetoFiltro.documento = ''"
              colorPlaceholder="#9E9E9E"
              placeholder="Escreva um CPF ou CNPJ"
              titulo="CPF/CNPJ"
              v-model="objetoFiltro.documento"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-campo-texto
              maxCaracteres="60"
              :icone="objetoFiltro.nomePrestador ? 'x' : ''"
              ladoIcone="direito"
              clickIcone
              @click-icone="objetoFiltro.nomePrestador = ''"
              colorPlaceholder="#9E9E9E"
              placeholder="Escreva o nome do prestador"
              titulo="Nome do prestador"
              v-model="objetoFiltro.nomePrestador"
            />
          </unicom-coluna>
        </unicom-linha>
      </div>
    </unicom-filtro-v2>
  </ValidationObserver>
</template>

<script>
/* eslint-disable */
import FiltroMixin from "../../../../shared/mixin/FiltroMixin";
import { ValidationObserver } from "vee-validate";

export default {
  mixins: [FiltroMixin],
  components: {
    ValidationObserver
  },
  props: {
    listaAnalistas: {
      type: Array,
      default: () => []
    },
    listaStatus: {
      type: Array,
      default: () => []
    },
    listaUnimedOrigem: {
      type: Array,
      default: () => []
    },
    listaTipos: {
      type: Array,
      default: () => []
    },
    listaRedes: {
      type: Array,
      default: () => []
    },
    limparUnimed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      objetoFiltro: {},
      objetoFiltroVazio: {
        tipo: {
          chave: "",
          descricao: ""
        },
        unimedOrigem: {
          chave: "",
          descricao: ""
        },
        rede: {
          chave: "",
          descricao: ""
        },
        documento: "",
        nomePrestador: "",
      }
    };
  },
  beforeMount() {
    this.objetoFiltro = JSON.parse(JSON.stringify(this.objetoFiltroVazio));
  },
  methods:{
    selecionarUnimed(index) {
      this.selecionarChave(index, "unimedOrigem", this.listaUnimedOrigem, "id");
      this.$emit("limpar-pesquisa");
    },
    filtrar(){ 
      const {
        tipo: { chave: chaveTipo },
        rede: { chave: chaveRede },
        unimedOrigem: { chave: chaveUnimedOrigem },
        documento,
        nomePrestador,
      } = this.objetoFiltro;

      const objetoFiltro = {
        cpfCnpj: documento.replace(/[^A-Za-z0-9]/g, "").toUpperCase(),
        nome: nomePrestador,
        rede: chaveRede,
        unimedOrigem: chaveUnimedOrigem,
        tipo: chaveTipo
      };

      this.$emit("filtrar", objetoFiltro);
      this.$emit("filtroPuro", this.objetoFiltro);
    }
  },
  watch: {
    limparUnimed() {
      if (this.limparUnimed) {
        // this.objetoFiltro.unimedOrigem = {
        //   chave: "",
        //   descricao: ""
        // };
        // this.$emit("unimed-limpada");
      }
    }
  }
};
</script>

<style lang="scss">
.espacamento-filtro {
  .col-12 {
    padding-top: 24px;
  }
}
</style>